import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface StructureNameFieldProps {
  placeholder?: string
  disabled?: boolean
}

export const StructureNameField: React.FC<StructureNameFieldProps> = ({
  placeholder,
  disabled,
}) => {
  const { control, register } = useFormContext<{ structure_name: string }>()

  return (
    <FormField
      name="structure_name"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Structure Name</FormLabel>
              <FormError />
            </div>
            <Input
              {...register('structure_name')}
              disabled={disabled}
              placeholder={placeholder ?? 'Enter a structure name'}
            />
          </FormItem>
        )
      }}
    />
  )
}
